import React, { useRef } from 'react';

import cx from 'classnames';
import { createPortal } from 'react-dom';
import OutsideClickHandler from 'react-outside-click-handler';

import useElementPosition from 'hooks/useElementPosition';

import EscKeyHandler from '../EscKeyHandler';
import styles from './index.module.css';

function Popover({ children, onClose, anchorEl, mountEl, style, className, position, isNormalize, shiftY, shiftX }) {
  const popoverRef = useRef();
  const { targetStyles } = useElementPosition(
    { mountEl, anchorEl, targetRef: popoverRef },
    { placement: position, isNormalize, shiftY, shiftX },
  );

  return createPortal(
    <OutsideClickHandler onOutsideClick={onClose}>
      <EscKeyHandler onEscapeClick={onClose}>
        <div ref={popoverRef} className={cx(styles.popover, className)} style={{ ...targetStyles, ...style }}>
          {children}
        </div>
      </EscKeyHandler>
    </OutsideClickHandler>,
    mountEl,
  );
}

export default Popover;
